import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-staff-manual-email-table",
	templateUrl: "./staff-manual-email-table.component.html",
	styleUrls: ["./staff-manual-email-table.component.css"],
})
export class StaffManualEmailTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() SendEmail: EventEmitter<any> = new EventEmitter();
	@Output() RemovePerson: EventEmitter<any> = new EventEmitter();
	@Input() Processing: boolean = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	@Input() lstPerson: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSendEmail() {
		this.SendEmail.emit(this.lstPerson);
	}

	ClearData() {
		this.lstPerson = [];
		this.SelectedPerson = null;
	}

	onRemove(Person) {
		this.onRowUnselect(null);
		this.RemovePerson.emit(Person);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
